import React from 'react';

import {
  SidePage,
  Logs,
  Log,
  LogText,
  TimeLineCollapse,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from '@gogame/components';
import { useLoadMarketingPlanningErrorLog } from 'scenes/MarketingPlanning/MarketingPlanningGrid/data';

const ErrorLog = ({ year, month, onClose, onExited, open }) => {
  const { data, isLoading, isRefetching } = useLoadMarketingPlanningErrorLog({
    year,
    month,
  });

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isRefetching}
      open={open}
      fullScreen={true}
    >
      <SidePage.Title title={'Error Log'} />
      <SidePage.NewBody>
        <Logs empty={!data?.length} fullWidth={true}>
          {data?.map(({ date, user, details }, i) => {
            const withDetails = Boolean(details?.length);
            const summary = <LogText date={date} user={user.name} />;
            return (
              <Log key={i} color={'error'}>
                {withDetails ? (
                  <TimeLineCollapse summary={summary}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align={'right'}>Row Number</TableCell>
                            <TableCell>Column</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Network</TableCell>
                            <TableCell>Application</TableCell>
                            <TableCell>Channel</TableCell>
                            <TableCell>Platform</TableCell>
                            <TableCell>Affiliate</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Manager</TableCell>
                            <TableCell>Owner</TableCell>
                            <TableCell>UA Budget</TableCell>
                            <TableCell>RE Budget</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {details.map(
                            (
                              {
                                rowNumber,
                                column,
                                description,
                                network,
                                application,
                                channel,
                                platform,
                                affiliate,
                                country,
                                manager,
                                owner,
                                reBudget,
                                uaBudget,
                              },
                              i
                            ) => {
                              return (
                                <TableRow key={i}>
                                  <TableCell align={'right'}>
                                    <Typography>{rowNumber}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{column}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{description}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{network}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{application}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{channel}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{platform}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{affiliate}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{country}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{manager}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{owner}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{uaBudget}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography>{reBudget}</Typography>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TimeLineCollapse>
                ) : (
                  summary
                )}
              </Log>
            );
          })}
        </Logs>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default ErrorLog;
